/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */


/* ++++++++++ --------------- EXPORT : COMMENTING CONFIGURATION ADVANCED SECTION - GUEST COMMENTING : STYLES --------------- ++++++++++ */
export default theme => ({
  guestcommenting: {
  }
});
